export default "__VITE_ASSET__0CK3HlxE__"